// extracted by mini-css-extract-plugin
export var divider = "_de-7";
export var itemsToggle = "_de-8";
export var mergeModal = "_de-1";
export var optionCard = "_de-4";
export var radioGroup = "_de-6";
export var radioOption = "_de-0";
export var selected = "_de-5";
export var shipmentOptions = "_de-2";
export var tableOptions = "_de-3";